import { apiClient } from './AbstractHTTPService'

const PATH = '/basedata/datetype/'

export default {
  getMyDates () {
    return apiClient.get('/date/user/')
  },
  getUserDateTypes () {
    return apiClient.get(PATH + '?MODULE=user')
  },

  getSpecialDateTypes () {
    return apiClient.get('/basedata/datetypespecial/')
  },
  getHistory (dateId) {
    return apiClient.get('/date/' + dateId + '/history/')
  }
}
